import { Link } from 'react-router-dom';

const AboutPreview = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Images – echte Fotos von gowitec.de */}
          <div className="relative">
            <div className="w-full h-[420px] rounded-xl overflow-hidden">
              <img
                src="/images/anlage2.jpg"
                alt="gowiTEC – Automatisierungsanlage"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
              />
            </div>
            {/* Kleines Overlay-Bild unten rechts */}
            <div className="absolute -bottom-5 -right-4 w-40 h-28 rounded-xl overflow-hidden border-4 border-white hidden md:block">
              <img
                src="/images/schrank1.jpg"
                alt="gowiTEC – Schaltschrank"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
              />
            </div>
            {/* Badge */}
            <div className="absolute -top-5 -left-4 bg-[#1E3A8A] text-white rounded-xl px-6 py-4 hidden md:block">
              <div className="text-3xl font-bold">1992</div>
              <div className="text-blue-200 text-xs mt-0.5">Gegründet</div>
            </div>
          </div>

          {/* Text */}
          <div>
            <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Über uns</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-6 leading-tight">
              Über 30 Jahre Erfahrung in der Automatisierungstechnik
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-5">
              Seit der Gründung 1992 steht gowiTEC für technische Kompetenz und persönliche Beratung. Als inhabergeführtes Unternehmen im Bergischen Land entwickeln wir individuelle Automatisierungslösungen für den Mittelstand und die Industrie.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              Unser Ansatz: Keine Standardlösungen, sondern maßgeschneiderte Systeme, die exakt auf Ihre Produktionsprozesse abgestimmt sind. Von der ersten Idee bis zur Inbetriebnahme – alles aus einer Hand.
            </p>

            <ul className="flex flex-col gap-3 mb-8">
              {[
                'Inhabergeführt und unabhängig',
                'Erfahrenes Team aus Ingenieuren und Technikern',
                'Projekte in ganz Deutschland und Europa',
                'Persönlicher Ansprechpartner für jedes Projekt',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-gray-700 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                    <i className="ri-check-line text-[#1E3A8A] font-bold"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <div className="flex flex-wrap gap-4">
              <Link
                to="/ueber-uns"
                className="inline-flex items-center gap-2 bg-[#1E3A8A] hover:bg-[#1e40af] text-white font-semibold px-7 py-3.5 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Mehr über uns
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </Link>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 border border-gray-300 hover:border-[#1E3A8A] text-gray-700 hover:text-[#1E3A8A] font-semibold px-7 py-3.5 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Kontakt aufnehmen
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
